module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento6.0199f7f0.svg";